import React from 'react'

const TablaLiquidarUnProcedimiento = ({item,nombreProcedimiento,codigoProcedimiento,isFacturable,selectedRows,handleRowSelect}) => {
  //handleRowSelect()
  return (
    <tbody>
    <tr className="divide-y divide-slate-700">
        <td></td>
          
          
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
            {/* {item.MPCedu? item.MPCedu:null} */}
            {/* {item.CrgCod} */}
            1
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {/* {nombreProcedimiento} */}
            1
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {codigoProcedimiento}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {nombreProcedimiento}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {/* {nombreProcedimiento} */}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {/* {nombreProcedimiento} */}
            {item.DescripcionHonorario}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {/* {nombreProcedimiento} */}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {/* {nombreProcedimiento} */}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {/* {nombreProcedimiento} */}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {/* {nombreProcedimiento} */}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.MPNOMC? item.MPNOMC:null} */}
            {isFacturable}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {item.ValorHonorario}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {/* {item.ValorHonorario} */}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            <input
              type="checkbox"
              checked={selectedRows.includes(item.CodigoHonorario)}
              onChange={() => handleRowSelect(item.CodigoHonorario)}
            />
          </td>
          
        </tr>
        
        </tbody>
  )
}

export default TablaLiquidarUnProcedimiento